/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListSkillDistributionsResult,
  ListSkillDistributionsResult$inboundSchema,
} from "../components/listskilldistributionsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListSkillDistributionsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSkillDistributionsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSkillDistributionsSecurity = {
  option1?: ListSkillDistributionsSecurityOption1 | undefined;
  option2?: ListSkillDistributionsSecurityOption2 | undefined;
};

export type ListSkillDistributionsRequest = {
  /**
   * Only return distributions of this skill.
   */
  skillId?: string | undefined;
  /**
   * Only return distributions carried by this plugin.
   */
  pluginId?: string | undefined;
  /**
   * Cursor for the next page of skill distributions.
   */
  cursor?: string | undefined;
  /**
   * The number of skill distributions to return per page.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListSkillDistributionsResponse = {
  result: ListSkillDistributionsResult;
};

/** @internal */
export type ListSkillDistributionsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSkillDistributionsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListSkillDistributionsSecurityOption1$Outbound,
    ListSkillDistributionsSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listSkillDistributionsSecurityOption1ToJSON(
  listSkillDistributionsSecurityOption1: ListSkillDistributionsSecurityOption1,
): string {
  return JSON.stringify(
    ListSkillDistributionsSecurityOption1$outboundSchema.parse(
      listSkillDistributionsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListSkillDistributionsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSkillDistributionsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListSkillDistributionsSecurityOption2$Outbound,
    ListSkillDistributionsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listSkillDistributionsSecurityOption2ToJSON(
  listSkillDistributionsSecurityOption2: ListSkillDistributionsSecurityOption2,
): string {
  return JSON.stringify(
    ListSkillDistributionsSecurityOption2$outboundSchema.parse(
      listSkillDistributionsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListSkillDistributionsSecurity$Outbound = {
  Option1?: ListSkillDistributionsSecurityOption1$Outbound | undefined;
  Option2?: ListSkillDistributionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSkillDistributionsSecurity$outboundSchema: z.ZodMiniType<
  ListSkillDistributionsSecurity$Outbound,
  ListSkillDistributionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListSkillDistributionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListSkillDistributionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSkillDistributionsSecurityToJSON(
  listSkillDistributionsSecurity: ListSkillDistributionsSecurity,
): string {
  return JSON.stringify(
    ListSkillDistributionsSecurity$outboundSchema.parse(
      listSkillDistributionsSecurity,
    ),
  );
}

/** @internal */
export type ListSkillDistributionsRequest$Outbound = {
  skill_id?: string | undefined;
  plugin_id?: string | undefined;
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSkillDistributionsRequest$outboundSchema: z.ZodMiniType<
  ListSkillDistributionsRequest$Outbound,
  ListSkillDistributionsRequest
> = z.pipe(
  z.object({
    skillId: z.optional(z.string()),
    pluginId: z.optional(z.string()),
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 20),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      skillId: "skill_id",
      pluginId: "plugin_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSkillDistributionsRequestToJSON(
  listSkillDistributionsRequest: ListSkillDistributionsRequest,
): string {
  return JSON.stringify(
    ListSkillDistributionsRequest$outboundSchema.parse(
      listSkillDistributionsRequest,
    ),
  );
}

/** @internal */
export const ListSkillDistributionsResponse$inboundSchema: z.ZodMiniType<
  ListSkillDistributionsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListSkillDistributionsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listSkillDistributionsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillDistributionsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillDistributionsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillDistributionsResponse' from JSON`,
  );
}
